module.exports = __webpack_public_path__ + "img/comments-alt.ad67f3aa.svg";